import React, { useEffect, useState } from 'react';
import { FlexWrapper, PaginationBox, ViewIconBox } from '../../theme/common_style';
import { Pagination, Table } from 'antd';
import { NoLeaveIcon, ViewIconNew } from '../../theme/SvgIcons';
import { useLocation, useNavigate } from 'react-router-dom';
import EmptyData from '../../components/common/EmptyData';
import { GetEmployeeLeavesApi } from '../../redux/lms/apiRoute';
import { toast } from 'react-toastify';
import {
  convertToLocalDate,
  convertToLocalTime,
  getCategory,
  getStatusTag
} from '../../utils/common_functions';
import { apiModules } from '../../utils/constant';

const EmployeeLeavesTable = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id: employeeId } = location.state || {};
  const limit = 20;
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(10);
  const [loading, setLoading] = useState(true);
  const [apiData, setApiData] = useState();
  const [sort, setSort] = useState({});

  const handleSorting = (val) => {
    if (val?.field) {
      let order = val?.order == 'ascend' ? 'ASC' : 'DESC';
      setSort({ sortBy: val?.columnKey, orderBy: order, ...val });
    }
    setPage(page);
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      params.append('page', page);
      params.append('limit', limit);
      params.append('moduleType', apiModules.LEAVE_MANAGEMENT_SUSTEM);
      sort?.sortBy && params.append('sort_by', sort?.sortBy);
      sort?.orderBy && params.append('sort_order', sort?.orderBy);

      const res = await GetEmployeeLeavesApi(params, employeeId);
      if (res?.statusCode == 200) {
        setApiData(res?.data?.leaves);
        setTotal(res?.data?.total);
      } else toast.error(res?.message || 'Something went wrong');
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, sort]);

  const columns = [
    {
      width: 120,
      title: 'Leave Type',
      dataIndex: 'leave_type',
      key: 'leave_type',
      render: (leave_type) => (
        <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor="default">
          <span>{leave_type}</span>
        </FlexWrapper>
      )
    },
    {
      width: 100,
      title: 'Applied On',
      dataIndex: 'created_at',
      key: 'created_at',
      sorter: true,
      render: (date) => (
        <FlexWrapper style={{ textAlign: 'center' }}>
          <span>{convertToLocalTime(date)}</span>
        </FlexWrapper>
      )
    },
    {
      width: 100,
      title: 'Start Date',
      dataIndex: 'start_date',
      key: 'start_date',
      sorter: true,
      render: (startDate) => (
        <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor="default">
          {convertToLocalDate(startDate)}
        </FlexWrapper>
      )
    },
    {
      width: 100,
      title: 'End Date',
      dataIndex: 'end_date',
      key: 'end_date',
      sorter: true,
      render: (endDate) => (
        <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor="default">
          {convertToLocalDate(endDate)}
        </FlexWrapper>
      )
    },
    {
      width: 120,
      title: 'Leave Category',
      dataIndex: 'leave_category',
      key: 'leave_category',
      render: (leave_category) => getCategory(leave_category) ?? 'N/A'
    },
    {
      width: 100,
      title: 'No of Leaves',
      dataIndex: 'no_of_leaves',
      key: 'no_of_leaves',
      render: (no_of_leaves) => (
        <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor="default">
          <span>{no_of_leaves || 'N/A'}</span>
        </FlexWrapper>
      )
    },
    {
      width: 90,
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => getStatusTag(status)
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      fixed: 'right',
      width: 60,
      render: (_, record) => {
        return (
          <FlexWrapper justify="center" gap="6px" cursor="pointer">
            <ViewIconBox
              onClick={() =>
                navigate(`/view-employee/leave`, {
                  state: { lms: record }
                })
              }>
              <ViewIconNew />
            </ViewIconBox>
          </FlexWrapper>
        );
      }
    }
  ];
  return (
    <div style={{ marginTop: '20px', backgroundColor: '#f3f6fc' }}>
      <FlexWrapper justify="start" width="100%" align="center" margin="0 0 15px">
        <div
          style={{
            fontFamily: 'Plus Jakarta Sans',
            fontWeight: 700,
            fontSize: '20px',
            color: '#0E0E0E'
          }}>
          Leaves
        </div>
      </FlexWrapper>

      {loading || apiData?.length > 0 ? (
        <div style={{ width: '100%' }}>
          <Table
            prefixCls="antCustomTable"
            scroll={{ x: '100%' }}
            columns={columns}
            dataSource={apiData}
            pagination={false}
            loading={loading}
            onChange={(_, __, sorter) => {
              if (!sorter.order) {
                setSort({});
              } else {
                handleSorting(sorter);
              }
            }}
            defaultSortOrder={sort.order}
          />
          {total > limit && (
            <PaginationBox>
              <Pagination
                current={page}
                prefixCls="custom-pagination"
                pageSize={limit}
                total={total}
                onChange={(e) => setPage(e)}
                showSizeChanger={false}
              />
            </PaginationBox>
          )}
        </div>
      ) : (
        <EmptyData
          height={'50vh'}
          icon={<NoLeaveIcon />}
          title={'No Leave'}
          subTitle={`There are no leave requested.`}
        />
      )}
    </div>
  );
};

export default EmployeeLeavesTable;
